// Require your custom property entries.
import spellProps,{ProcessVariables,ConditionalVariable,PrefixVariable} from "./SpellProps";
import { is } from 'bpmn-js/lib/util/ModelUtil';

var LOW_PRIORITY = 500;

// Create the custom magic tab.
// The properties are organized in groups.
function createMagicTabGroups(element, translate) 
	{
  // Create a group called "Black Magic".
	  var blackMagicGroup = 
		{
		id: "black-magic",
		label: "Black Magic",
		entries: []
		};

  // Add the spell props to the black magic group.
	spellProps(blackMagicGroup, element, translate);
	return [blackMagicGroup];
	}

export default function MagicPropertiesProvider(propertiesPanel,translate,injector)
	{
	this.getGroups=function(element)
		{
		return function(groups)
			{
			if (is(element,'bpmn:Task')||is(element,'bpmn:SubProcess'))
				groups.push(createMagicGroup(element,translate));

			if (is(element,'bpmn:SequenceFlow')||is(element,'bpmn:ComplexGateway'))
				groups.push(createConditionalVariable(element,translate));

			if (is(element,'bpmn:Collaboration'))
				{
				groups.push(createPrefixVariable(element,translate));
				groups.push(ProcessVariables(element,injector));
				}
			return groups;
			};
		};

	propertiesPanel.registerProvider(LOW_PRIORITY,this);
	}





function createPrefixVariable(element, translate)
	{
	const magicGroup = {
		id: 'prefixProcess',
		label: translate('Prefix Name'),
		entries: PrefixVariable(element),
//		tooltip: translate('Make sure you know what you are doing!')
		};
	return magicGroup;	
	}

function createConditionalVariable(element, translate)
	{
	const magicGroup = {
		id: 'conditionalVariable',
		label: translate('Conditional Variable/Expression'),
		entries: ConditionalVariable(element),
//		tooltip: translate('Make sure you know what you are doing!')
		};
	return magicGroup;	
	}

function createMagicGroup(element, translate) 
	{
//	console.log(element);
	// create a group called "Magic properties".
	const magicGroup = {
		id: 'formInfo',
		label: translate('Related Form'),
		entries: spellProps(element),
//		tooltip: translate('Make sure you know what you are doing!')
		};
	return magicGroup;
	}

MagicPropertiesProvider.$inject = ["propertiesPanel", "translate","injector"];
